import { store } from '../../index'
import { reportError } from 'j-comps'
import config from '../../config'
import { apiGetDesigns, apiCreateDesign, apiDeleteDesign } from '../../api'

export const getDesigns = async (memberId) => {
  try {
    const designs = await apiGetDesigns(memberId)
    store.dispatch({
      type: 'SET_DESIGNS',
      designs,
    })
  } catch (error) {
    const errorMessage = `Could not set ${config.vendor.name.titleCase} designs`
    return reportError(store, errorMessage, error)
  }
}

export const createDesign = async (exportUrl, designId, memberId) => {
  try {
    await apiCreateDesign(exportUrl, designId, memberId)
    getDesigns(memberId)
  } catch (error) {
    const errorMessage = `Could not create ${config.vendor.name.titleCase} design`
    return reportError(store, errorMessage, error)
  }
}

export const deleteDesign = async (key) => {
  try {
    const r = window.confirm('This will delete the image permanently')
    if (r === true) {
      await apiDeleteDesign(key)
      store.dispatch({
        type: 'DELETE_DESIGN',
        key,
      })
    }
  } catch (error) {
    const errorMessage = `Could not delete ${config.vendor.name.titleCase} design`
    return reportError(store, errorMessage, error)
  }
}
